import { throwApiError } from '@/shared/utils/apiResponse';
import { apiDelete, apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';
import type {
  MuteItem,
  NotificationCategory,
  NotificationPreferencesView,
  PreferencesData,
} from '@/types/notificationPreferences/types';

const unwrap = async <T>(response: Response, defaultMsg: string): Promise<T> => {
  if (!response.ok) await throwApiError(response, defaultMsg);
  const json = (await response.json()) as { data?: T };
  if (!json.data) throw new Error(defaultMsg);
  return json.data;
};

export type CreateMuteInput =
  | { scope: 'CATEGORY'; category: NotificationCategory }
  | { scope: 'ENTITY'; entityType: string; entityId: string };

export const notificationPreferencesService = {
  fetch: async (): Promise<NotificationPreferencesView> => {
    const response = await apiGet('/notifications/preferences');
    return unwrap<NotificationPreferencesView>(response, 'Erro ao buscar preferências');
  },

  patch: async (data: Partial<PreferencesData>): Promise<NotificationPreferencesView> => {
    const response = await apiPatch('/notifications/preferences', data);
    return unwrap<NotificationPreferencesView>(response, 'Erro ao salvar preferências');
  },

  createMute: async (input: CreateMuteInput): Promise<MuteItem> => {
    const response = await apiPost('/notifications/mute', input);
    return unwrap<MuteItem>(response, 'Erro ao silenciar notificação');
  },

  deleteMute: async (id: string): Promise<void> => {
    const response = await apiDelete(`/notifications/mute/${id}`);
    if (!response.ok && response.status !== 204) {
      await throwApiError(response, 'Erro ao remover silenciamento');
    }
  },
};
